import type { CurrencyEnum } from '@/Shared/AutoGenerated/Main'
import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class Money {
    constructor(
        public readonly value: number,
        public readonly currency: CurrencyEnum.USD,
    ) {
        ensureNoUndefinedProperties(this)
    }

    multiply(multiplier: number): Money {
        return new Money(this.value * multiplier, this.currency)
    }

    getValueAsDecimal(): string {
        const decimalAmount = this.value / 100

        return Number.parseFloat(`${decimalAmount}`).toFixed(2)
    }
}
